import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    InventoryAdditionalFilters,
    InventoryFeedInput,
    InventoryFeedResponse,
    InventoryItemEntry,
    InventoryStatusFilter,
} from '../../types/inventory';
export type {
    InventoryItemEntry,
    InventoryAdditionalFilters,
    InventoryStatusFilter,
};

const getInventoryFeed = async (
    sessionId: string,
    input: InventoryFeedInput,
): Promise<InventoryFeedResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/feed`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useInventoryFeed = (
    statusFilter: InventoryStatusFilter = 'active',
    locationIds: Array<string> | 'all',
    page: number = 1,
    limit: number = 20,
    search: string = '',
    additionalFilters: InventoryAdditionalFilters = {},
) => {
    const sessionContext = useContext(SessionContext);
    const offset = (page - 1) * limit;

    return useQuery({
        queryKey: [
            '/inventory/feed',
            sessionContext?.organizationId ?? '',
            statusFilter,
            locationIds === 'all' ? 'all' : locationIds.join(','),
            page,
            limit,
            search,
            JSON.stringify(additionalFilters),
        ],
        queryFn: () => {
            const feedLocationIds =
                locationIds === 'all' || locationIds.length === 0 ? 'all' : locationIds;

            const input: InventoryFeedInput = {
                statusFilter,
                locationIds: feedLocationIds,
                limit,
                offset,
                search: search || undefined,
                additionalFilters:
                    Object.keys(additionalFilters).length > 0 ? additionalFilters : undefined,
            };

            return getInventoryFeed(sessionContext?.sessionId ?? '', input);
        },
        enabled: !!sessionContext?.sessionId,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchInterval: 1000 * 60 * 5,
    });
};
